<template>
  <div>
    <b-modal
      v-model="isError"
      :active="isError"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isError = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image" /></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section
                class="container section page-header section is-main-section"
              >
                <error-page></error-page>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="isSuccess"
      :active="isSuccess"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isSuccess = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image" /></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section
                class="container section page-header section is-main-section"
              >
                <thank-you
                  :OfflineCaptureRespos="OfflineCaptureRespos"
                  :title="title"
                  noOfPage="2"
                  :isPrint="isPrint"
                ></thank-you>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <v-container v-if="studentInfo" fluid>
      <div v-if="studentInfo">
        <v-card-component>
          <v-row key="1">
            <v-col cols="12" md="2" lg="2" xl="2" align="center">
              <v-img :src="tots_image" width="120"> </v-img>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Enquiry Code
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo.enquiryCode ? studentInfo.enquiryCode : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Student Name
                  </div>
                  <span
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.studentFirstName
                        ? studentInfo.studentFirstName + ' '
                        : ' '
                    "
                  >
                  </span>
                  <span
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.studentLastName
                        ? studentInfo.studentLastName
                        : ' '
                    "
                  >
                  </span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Franchisee Name
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.franchisee.companyName
                        ? studentInfo.franchisee.companyName
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Academic Year
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.academicYear.academicYear
                        ? studentInfo.academicYear.academicYear
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Class</div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.class ? studentInfo.class : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row key="2">
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Parent / Guardian Name
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.fatherName
                        ? studentInfo.fatherName
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  Parent / Guardian Mobile
                  <div class="grey--text text-subtitle-2 mb-1"></div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.fatherMobile
                        ? studentInfo.fatherMobile
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Parent / Guardian Email
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.fatherEmailID
                        ? studentInfo.fatherEmailID
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Student Gender
                  </div>
                  <div
                    v-if="
                      studentInfo.gender === 'Female' ||
                      studentInfo.gender === 'FEMALE'
                    "
                    class="text-button mb-1"
                    v-text="
                      studentInfo &&
                      studentInfo.gender &&
                      studentInfo.gender === 'Female'
                        ? 'Girl'
                        : '-' ||
                          (studentInfo &&
                            studentInfo.gender &&
                            studentInfo.gender === 'FEMALE')
                        ? 'Girl'
                        : '-'
                    "
                  ></div>
                  <div
                    v-if="
                      studentInfo.gender === 'Male' ||
                      studentInfo.gender === 'MALE'
                    "
                    class="text-button mb-1"
                    v-text="
                      studentInfo &&
                      studentInfo.gender &&
                      studentInfo.gender === 'Male'
                        ? 'Boy'
                        : '-' ||
                          (studentInfo &&
                            studentInfo.gender &&
                            studentInfo.gender === 'MALE')
                        ? 'Boy'
                        : '-'
                    "
                  ></div>
                  <div v-if="studentInfo.gender === null" class="mb-1">-</div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Section / Division
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="studentInfo.section ? studentInfo.section : '-'"
                  ></div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-component>
        <v-row key="3">
          <v-col cols="12">
            <template>
              <v-stepper elevation="0" v-model="stepper">
                <v-stepper-header>
                  <v-stepper-step :complete="stepper > 1" step="1">
                    Payment Details
                  </v-stepper-step>

                  <v-divider></v-divider>
                  <v-stepper-step :complete="stepper > 2" step="2">
                    Payment Mode
                  </v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1" class="stepper_content">
                    <v-card-component>
                      <v-row>
                        <v-col cols="12" md="2" sm="4">
                          <div class="d-flex justify-space-between caption">
                            <div>
                              <div
                                class="text-subtitle-2 mb-1"
                                style="color: #000"
                              >
                                Total Amount
                              </div>
                              <div
                                class="text-button mb-1"
                                v-text="
                                  feeSummaryInfo.totalAmount
                                    ? Number(
                                        feeSummaryInfo.totalAmount
                                      ).toFixed(2)
                                    : 0
                                "
                              ></div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="2" sm="4">
                          <div class="d-flex justify-space-between caption">
                            <div>
                              <div
                                class="text-subtitle-2 mb-1"
                                style="color: #000"
                              >
                                Amount Paid
                              </div>
                              <div
                                class="text-button mb-1"
                                v-text="
                                  feeSummaryInfo.amountPaid
                                    ? Number(feeSummaryInfo.amountPaid).toFixed(
                                        2
                                      )
                                    : 0
                                "
                              ></div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="2" sm="4">
                          <div class="d-flex justify-space-between caption">
                            <div>
                              <div
                                class="text-subtitle-2 mb-1"
                                style="color: #000"
                              >
                                Remaining Amount
                              </div>
                              <div
                                class="text-button mb-1"
                                v-text="
                                  feeSummaryInfo.remainingAmount
                                    ? Number(
                                        feeSummaryInfo.remainingAmount
                                      ).toFixed(2)
                                    : 0
                                "
                              ></div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                          <div class="d-flex justify-space-between caption">
                            <div>
                              <div
                                class="text-subtitle-2 mb-1"
                                style="color: #000"
                              >
                                Enter Amount
                              </div>
                              <v-text-field
                                outlined
                                class="my-1"
                                v-model="remainingPaidAmount"
                                type="number"
                                :min="compulsoryPayable"
                                dense
                                :error="payableAmountError"
                                :error-messages="payableAmountErrorMsg"
                                :hint="`Minimum Amount to be paid is Rs. ${minimumPayableAmount}`"
                                persistent-hint
                                @input="validatePayableAmount"
                                @keydown="handleExponential($event)"
                              />
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="2" sm="4">
                          <div class="d-flex justify-space-between caption">
                            <v-btn
                              class="mt-2"
                              success
                              icon-right="arrow-right-bold"
                              color="success"
                              @click="openPayNowDialog"
                            >
                              Proceed to Pay (<span
                                class="mdi mdi-currency-inr"
                              ></span
                              >{{ Number(remainingPaidAmount).toFixed(2) }})
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-component>
                    <div v-if="$vuetify.breakpoint.smAndUp">
                      <v-toolbar flat class="d-flex justify-center">
                        <v-toolbar-title
                          >Fee Structure (In Installments)</v-toolbar-title
                        >
                      </v-toolbar>
                      <v-data-table
                        :headers="headers"
                        :items="feeTypeGroup"
                        :single-expand="true"
                        show-expand
                        hide-default-footer
                        class="elevation-1"
                        item-key="feeTypeName"
                      >
                        <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length" class="pb-4 pt-4">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <!-- <th class="text-center">Pay Now</th> -->
                                    <th class="text-center">
                                      Installment Name
                                    </th>
                                    <th class="text-center">Amount</th>
                                    <th class="text-center" v-if="isConcession">
                                      Concession Amount
                                    </th>
                                    <th class="text-center">Amount Due</th>

                                    <!-- <th class="text-center" v-if="isGST && !isIGST">
                                    CGST Amount
                                  </th>

                                  <th class="text-center" v-if="isGST && !isIGST">
                                    SGST Amount
                                  </th>

                                  <th class="text-center" v-if="isGST && isIGST">
                                    IGST Amount
                                  </th> -->

                                    <th class="text-center">Amount To Pay</th>
                                    <th class="text-center">Due Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="element in item.installments"
                                    :key="element.id"
                                  >
                                    <!-- <td align="center">
                                    <v-checkbox class="shrink mr-0 mt-0" readonly :value="true" v-model="element.isChecked" :disabled="element.isCompulsory" hide-details></v-checkbox>
                                  </td> -->
                                    <td align="center" justify="center">
                                      {{ element.name }}
                                    </td>
                                    <td align="center" justify="center">
                                      {{ Number(element.amount).toFixed(2) }}
                                    </td>
                                    <td
                                      align="center"
                                      justify="center"
                                      v-if="isConcession"
                                    >
                                      {{
                                        Number(
                                          element.amountConcession
                                        ).toFixed(2)
                                      }}
                                    </td>
                                    <td align="center" justify="center">
                                      {{ Number(element.amountDue).toFixed(2) }}
                                    </td>
                                    <!-- <td align="center" justify="center" v-if="isGST && !isIGST">{{ Number(element.cGSTAmt).toFixed(2) }}</td>
                                  <td align="center" justify="center" v-if="isGST && !isIGST">{{ Number(element.sGSTAmt).toFixed(2) }}</td>
                                  <td align="center" justify="center" v-if="isGST && isIGST">{{ Number(element.iGSTAmt).toFixed(2) }}</td> -->
                                    <td align="center" justify="center">
                                      {{
                                        Number(element.payableAmt).toFixed(2)
                                      }}
                                    </td>
                                    <td align="center" justify="center">
                                      {{
                                        new Date(
                                          element.dueDate
                                        ).toLocaleDateString()
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </td>
                        </template>
                        <template v-slot:body.append="{ headers }">
                          <tr
                            :class="{
                              'v-data-table__mobile-table-row':
                                $vuetify.breakpoint.xs,
                              ' ': $vuetify.breakpoint.smAndUp
                            }"
                          >
                            <td
                              :class="{
                                'v-data-table__mobile-row':
                                  $vuetify.breakpoint.xs,
                                'text-center': $vuetify.breakpoint.smAndUp
                              }"
                              v-for="(header, i) in headers"
                              :key="i"
                            >
                              <div
                                :class="{
                                  'v-data-table__mobile-row__cell':
                                    $vuetify.breakpoint.xs,
                                  ' ': $vuetify.breakpoint.smAndUp
                                }"
                                v-if="i === 0"
                                class="text-subtitle-2"
                              >
                                Totals
                              </div>
                              <div
                                :class="{
                                  'v-data-table__mobile-row__cell':
                                    $vuetify.breakpoint.xs,
                                  ' ': $vuetify.breakpoint.smAndUp
                                }"
                                v-if="header.value == 'totalAmount'"
                                class="text-subtitle-2"
                              >
                                <span class="mdi mdi-currency-inr"></span
                                >{{ totalAmount.toFixed(2) }}
                              </div>
                              <div
                                :class="{
                                  'v-data-table__mobile-row__cell':
                                    $vuetify.breakpoint.xs,
                                  ' ': $vuetify.breakpoint.smAndUp
                                }"
                                class="text-subtitle-2"
                                v-if="
                                  isConcession &&
                                  header.value == 'totalConcession'
                                "
                              >
                                <span class="mdi mdi-currency-inr"></span
                                >{{ totalConcession.toFixed(2) }}
                              </div>
                              <div
                                :class="{
                                  'v-data-table__mobile-row__cell':
                                    $vuetify.breakpoint.xs,
                                  ' ': $vuetify.breakpoint.smAndUp
                                }"
                                v-if="header.value == 'totalAmountDue'"
                                class="text-subtitle-2"
                              >
                                <span class="mdi mdi-currency-inr"></span
                                >{{ totalAmountDue.toFixed(2) }}
                              </div>
                              <!-- <div
                              :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                              class=" text-subtitle-2"
                              v-if="isGST && isIGST && header.value == 'totalIGST'"
                            >
                              <span class="mdi mdi-currency-inr"></span>{{ totalIGST.toFixed(2) }}
                            </div>
                            <div
                              :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                              class=" text-subtitle-2"
                              v-if="isGST && !isIGST && header.value == 'totalCGST'"
                            >
                              <span class="mdi mdi-currency-inr"></span>{{ totalCGST.toFixed(2) }}
                            </div>
                            <div
                              :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                              class=" text-subtitle-2"
                              v-if="isGST && !isIGST && header.value == 'totalSGST'"
                            >
                              <span class="mdi mdi-currency-inr"></span>{{ totalSGST.toFixed(2) }}
                            </div> -->
                              <div
                                :class="{
                                  'v-data-table__mobile-row__cell':
                                    $vuetify.breakpoint.xs,
                                  ' ': $vuetify.breakpoint.smAndUp
                                }"
                                v-if="header.value == 'totalAmountPayable'"
                                class="text-subtitle-2"
                              >
                                <span class="mdi mdi-currency-inr"></span
                                >{{ Number(totalAmountToPay).toFixed(2) }}
                              </div>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </div>
                    <!-- Mobile Views   -->
                    <div v-else>
                      <v-card-actions>
                        <v-card-title class="text-overline"
                          >DETAILS</v-card-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          color="accent"
                          @click="modalOpen()"
                          text
                          outlined
                        >
                          <v-icon left> mdi-information-variant</v-icon>
                        </v-btn>
                      </v-card-actions>
                      <div
                        v-for="(feeName, index) in feeTypeGroup"
                        :key="index"
                        class="text-subtitle-1 font-weight-light"
                      >
                        <v-row class="ma-0" no-gutters>
                          <v-col cols="12" md="3">
                            <v-card-actions>
                              <span class="black--text">Fee Type :</span>

                              <v-row align="center" justify="end" class="ma-1">
                                <span>
                                  {{ feeName.feeTypeName }}
                                </span>
                              </v-row>
                            </v-card-actions>
                          </v-col>

                          <!-- <v-col cols="12" md="4">
                          <v-card-actions>
                            <span class="black--text ">Installments:</span>

                            <v-row align="center" justify="end" class="ma-0">
                              <span>
                                <v-text-field v-model="feeName.position" readonly class="centered-input" style="float:right; width:65%" dense hide-details="true">
                                  <v-icon slot="append" color="green" @click="changeInstallments('plus', feeName)">
                                    mdi-plus
                                  </v-icon>
                                  <v-icon slot="prepend" color="red" @click="changeInstallments('minus', feeName)">
                                    mdi-minus
                                  </v-icon>
                                </v-text-field>
                              </span>
                            </v-row>
                          </v-card-actions>
                        </v-col> -->

                          <v-col cols="12" md="4">
                            <v-card-actions>
                              <span class="black--text">Amount to pay :</span>

                              <v-row align="center" justify="end" class="ma-1">
                                <span
                                  class="mdi mdi-currency-inr font-weight-bold black--text"
                                  >{{ feeName.totalAmountPayable }}</span
                                >
                              </v-row>
                            </v-card-actions>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                      </div>
                      <v-divider class="my-0"></v-divider>
                      <v-card-actions>
                        <span class="text-h5"> Totals </span>
                        <v-spacer></v-spacer>
                        <div
                          v-for="(header, i) in feeTypeGroup.slice(0, 1)"
                          :key="i"
                          class="text-h5 mr-2"
                        >
                          <span class="mdi mdi-currency-inr">{{
                            Number(totalAmountToPay).toFixed(2)
                          }}</span>
                        </div>
                      </v-card-actions>
                      <!-- <v-col cols="12">
                      <v-row align="end" justify="end">
                        <v-btn color="success" @click="stepper = 2" elevation="1">
                          Proceed to pay
                        </v-btn>
                      </v-row>
                    </v-col> -->
                    </div>
                    <v-dialog
                      v-model="dialogPop"
                      max-width="1200"
                      :active="dialogPop"
                      persistent
                    >
                      <v-card>
                        <v-toolbar dark color="darkblue">
                          <v-toolbar-title>Installments</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn
                              icon
                              dark
                              @click="
                                () => {
                                  dialogPop = false
                                }
                              "
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>

                        <v-stepper v-model="stepperPopUp">
                          <v-stepper-header class="stepper">
                            <div
                              v-for="(feeName, index) in feeTypeGroup"
                              :key="index"
                            >
                              <v-stepper-step
                                :step="index + 1"
                                editable
                                class="steps_items"
                              >
                                {{ feeName.feeTypeName }}
                              </v-stepper-step>
                              <!-- <v-divider v-if="index+1 < feeName.length" ></v-divider> -->
                            </div>
                          </v-stepper-header>
                          <v-stepper-items>
                            <v-stepper-content
                              v-for="(feeName, index) in feeTypeGroup"
                              :key="index"
                              :step="index + 1"
                            >
                              <div v-show="$vuetify.breakpoint.smAndDown">
                                <v-card-title class="text-overline">{{
                                  feeName.feeTypeName
                                }}</v-card-title>
                                <v-divider class="my-0"></v-divider>
                              </div>
                              <div>
                                <v-data-table
                                  :headers="installmentHeaders"
                                  :items="feeName.installments"
                                  disable-sort
                                  hide-default-footer
                                  class="elevation-1"
                                >
                                  <template v-slot:item.name="{ item }">
                                    <span>{{ item.name }} </span>
                                  </template>
                                  <template v-slot:item.amount="{ item }">
                                    <span>
                                      {{ Number(item.amount).toFixed(2) }}</span
                                    >
                                  </template>
                                  <template
                                    v-slot:item.amountConcession="{ item }"
                                  >
                                    <span>
                                      {{
                                        Number(item.amountConcession).toFixed(2)
                                      }}</span
                                    >
                                  </template>
                                  <template v-slot:item.dueDate="{ item }">
                                    <span>
                                      {{
                                        new Date(
                                          item.dueDate
                                        ).toLocaleDateString()
                                      }}
                                    </span>
                                  </template>
                                  <template v-slot:item.amountDue="{ item }">
                                    <span>
                                      {{
                                        Number(item.amountDue).toFixed(2)
                                      }}</span
                                    >
                                  </template>
                                  <!-- <template v-slot:item.cGSTAmt="{item}">
                                 <span> {{ Number(item.cGSTAmt).toFixed(2) }}</span>
                                 </template>
                                  <template v-slot:item.sGSTAmt="{item}">
                                <span> {{ Number(item.sGSTAmt).toFixed(2) }}</span>
                                 </template>
                                 <template v-slot:item.iGSTAmt="{item}">
                               <span> {{ Number(item.iGSTAmt).toFixed(2) }}</span>
                                 </template> -->
                                  <template v-slot:item.payableAmt="{ item }">
                                    <span>
                                      {{
                                        Number(item.payableAmt).toFixed(2)
                                      }}</span
                                    >
                                  </template>
                                </v-data-table>
                              </div>
                              <v-card-actions
                                v-if="$vuetify.breakpoint.smAndUp"
                              >
                                <v-row align="end" justify="end" class="ma-1">
                                  <v-btn
                                    color="primary"
                                    @click="nextStep(index + 1)"
                                    elevation="1"
                                    absolute
                                    top
                                    right
                                    fab
                                  >
                                    Next
                                  </v-btn>
                                </v-row>
                              </v-card-actions>
                              <v-card-actions v-else>
                                <v-row align="end" justify="end" class="ma-1">
                                  <v-btn
                                    color="primary"
                                    @click="nextStep(index + 1)"
                                    elevation="1"
                                    absolute
                                    top
                                    right
                                    fab
                                    small
                                  >
                                    <v-icon>mdi-arrow-right</v-icon>
                                  </v-btn>
                                </v-row>
                              </v-card-actions>
                            </v-stepper-content>
                          </v-stepper-items>
                        </v-stepper>
                      </v-card>
                    </v-dialog>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <v-container fluid>
                      <form>
                        <v-row>
                          <v-col cols="12">
                            <v-card-title
                              class="ma-0 pa-0 mb-4"
                              v-if="$vuetify.breakpoint.smAndUp"
                              >Payment Mode</v-card-title
                            >
                            <v-card-title
                              class="ma-0 pa-0 mb-4 text-subtitle-1 font-weight-bold"
                              v-else
                              >Payment Mode</v-card-title
                            >
                            <v-tabs
                              v-model="model"
                              left
                              slider-color="#000"
                              dark
                              background-color="primary lighten-2"
                              show-arrows
                            >
                              <v-tab class="text-overline">Cash</v-tab>
                              <v-tab class="text-overline">Cheque</v-tab>
                              <v-tab class="text-overline">
                                Credit/Debit card swipe</v-tab
                              >
                              <v-tab class="text-overline"
                                >Internet Payment</v-tab
                              >
                              <v-tab class="text-overline">Demand Draft</v-tab>
                            </v-tabs>
                            <v-divider class="my-0"></v-divider>
                            <v-tabs-items v-model="model">
                              <v-tab-item>
                                <v-card flat>
                                  <!-- <v-card-text>
                                    hi
                                  </v-card-text> -->
                                </v-card>
                              </v-tab-item>
                              <v-tab-item>
                                <v-card flat>
                                  <v-card-text>
                                    <v-card-title
                                      v-if="$vuetify.breakpoint.smAndUp"
                                    >
                                      Enter Cheque Details
                                      <v-icon color="primary" right
                                        >mdi-information</v-icon
                                      >
                                    </v-card-title>
                                    <v-card-title
                                      v-else
                                      class="text-subtitle-1 font-weight-bold"
                                    >
                                      Enter Cheque Details
                                      <v-icon color="primary" right medium
                                        >mdi-information</v-icon
                                      >
                                    </v-card-title>
                                    <v-divider class="my-0"></v-divider>
                                  </v-card-text>
                                  <v-container>
                                    <form>
                                      <v-row>
                                        <v-col cols="12" md="6">
                                          <v-row>
                                            <v-col cols="12">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Cheque No.
                                                <span class="error--text"
                                                  >*</span
                                                ></label
                                              >
                                              <v-text-field
                                                single-line
                                                placeholder="Cheque No."
                                                class="my-0 py-1"
                                                v-model="cheque.chequeNO"
                                              >
                                              </v-text-field>
                                            </v-col>

                                            <v-col
                                              cols="12"
                                              v-if="
                                                cheque.paymentType &&
                                                cheque.paymentType !==
                                                  'IFSC_CODE'
                                              "
                                            >
                                              <label
                                                class="font-weight-medium body-2"
                                                >MICR Code
                                                <span class="error--text"></span
                                              ></label>
                                              <v-text-field
                                                single-line
                                                placeholder="MICR Code"
                                                v-model="cheque.MICRCode"
                                                class="my-0 py-1"
                                              >
                                              </v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Bank Branch
                                              </label>
                                              <v-text-field
                                                single-line
                                                placeholder="Bank Branch"
                                                v-model="cheque.branchName"
                                                class="my-0 py-1"
                                              >
                                              </v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Cheque Date</label
                                              >
                                              <custom-date-picker
                                                prepend-icon="mdi-calendar"
                                                v-model="cheque.chequeDate"
                                              ></custom-date-picker>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                          <v-row>
                                            <!-- <v-col cols="12">
                              <label class="font-weight-medium body-2">Search By</label>
                              <v-autocomplete placeholder="--Select--" class="my-0 py-1" :items="admissionType" :item-text="text" :item-value="value"> </v-autocomplete>
                            </v-col> -->
                                            <v-col cols="12">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Type</label
                                              >
                                              <v-autocomplete
                                                placeholder="--Select--"
                                                class="my-0 py-1"
                                                v-model="cheque.paymentType"
                                                :items="bankIFSC"
                                                item-text="text"
                                                item-value="value"
                                                key="value"
                                              >
                                              </v-autocomplete>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              v-if="
                                                cheque.paymentType &&
                                                cheque.paymentType !==
                                                  'MICR_CODE'
                                              "
                                            >
                                              <label
                                                class="font-weight-medium body-2"
                                                >IFSC Code
                                              </label>
                                              <v-text-field
                                                single-line
                                                placeholder="IFSC Code"
                                                v-model="cheque.IFSCCode"
                                                class="my-0 py-1"
                                              >
                                              </v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Bank Name
                                                <span class="error--text"
                                                  >*</span
                                                ></label
                                              >
                                              <v-text-field
                                                single-line
                                                placeholder="Bank Name"
                                                v-model="cheque.bankName"
                                                class="my-0 py-1"
                                              >
                                              </v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </form>
                                  </v-container>
                                </v-card>
                              </v-tab-item>
                              <v-tab-item>
                                <v-card flat>
                                  <v-card-text>
                                    <v-card-title
                                      v-show="$vuetify.breakpoint.lg"
                                    >
                                      Enter Credit/Debit card swipe Details
                                      <!-- <v-icon color="primary" right>mdi-information</v-icon> -->
                                    </v-card-title>
                                    <v-card-title
                                      v-show="$vuetify.breakpoint.mdAndDown"
                                      class="text-subtitle-1 font-weight-bold"
                                    >
                                      Enter Credit/Debit card swipe Details
                                      <!-- <v-icon color="primary" right medium>mdi-information</v-icon> -->
                                    </v-card-title>
                                    <v-divider class="my-0"></v-divider>
                                  </v-card-text>
                                  <v-container>
                                    <form>
                                      <v-row>
                                        <v-col cols="12" md="6">
                                          <v-row>
                                            <v-col cols="12" md="7">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Card Type
                                                <span class="error--text"
                                                  >*</span
                                                ></label
                                              >
                                              <v-autocomplete
                                                placeholder="--Select--"
                                                class="my-0 py-1"
                                                v-model="
                                                  cardSwipe.transactionType
                                                "
                                                :items="cardType"
                                                item-text="text"
                                                item-value="value"
                                                key="value"
                                              >
                                              </v-autocomplete>
                                            </v-col>
                                            <!--
                            <v-col cols="12" md="5">
                              <label class="font-weight-medium body-2">Date</label>
                              <custom-date-picker prepend-icon="mdi-calendar"></custom-date-picker>
                            </v-col> -->
                                            <v-col cols="12">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Bank Name
                                                <span class="error--text"
                                                  >*</span
                                                ></label
                                              >
                                              <v-text-field
                                                single-line
                                                placeholder="Bank Name"
                                                v-model="cardSwipe.bankName"
                                                class="my-0 py-1"
                                              >
                                              </v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                          <v-row>
                                            <v-col cols="12" md="6">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Card Last 4 digits
                                                <span class="error--text"
                                                  >*</span
                                                >
                                              </label>
                                              <v-text-field
                                                single-line
                                                placeholder="CARD LAST DIGIT"
                                                v-model="
                                                  cardSwipe.cardLastFourDigit
                                                "
                                                class="my-0 py-1"
                                              ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Approved Code
                                                <span class="error--text"
                                                  >*</span
                                                ></label
                                              >
                                              <v-text-field
                                                single-line
                                                placeholder="APPROVED CODE"
                                                v-model="cardSwipe.approvalCode"
                                                class="my-0 py-1"
                                              >
                                              </v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                              <label
                                                class="font-weight-medium body-2"
                                                >Remarks
                                              </label>
                                              <v-text-field
                                                single-line
                                                placeholder="Remarks"
                                                v-model="cardSwipe.remark"
                                                class="my-0 py-1"
                                              >
                                              </v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </form>
                                  </v-container>
                                </v-card>
                              </v-tab-item>
                              <v-tab-item>
                                <v-card flat>
                                  <v-card-text>
                                    <v-card-title
                                      v-show="$vuetify.breakpoint.lg"
                                    >
                                      Enter Internet Payment Details
                                    </v-card-title>
                                    <v-card-title
                                      v-show="$vuetify.breakpoint.mdAndDown"
                                      class="text-subtitle-1 font-weight-bold"
                                    >
                                      Enter Internet Payment Details
                                    </v-card-title>
                                    <v-divider class="my-0"></v-divider>
                                  </v-card-text>
                                  <v-container>
                                    <form>
                                      <v-row>
                                        <v-col cols="12" md="3">
                                          <label
                                            class="font-weight-medium body-2"
                                            >Options</label
                                          >

                                          <v-autocomplete
                                            v-model="
                                              internetPayment.transactionType
                                            "
                                            placeholder="--Select--"
                                            class="my-0 py-1"
                                            :items="paymentMode"
                                            item-value="name"
                                            item-text="name"
                                          >
                                          </v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" md="3">
                                          <label
                                            class="font-weight-medium body-2"
                                            >Bank Name
                                          </label>
                                          <v-text-field
                                            single-line
                                            placeholder="Bank Name"
                                            v-model="internetPayment.bankName"
                                            class="my-0 py-1"
                                          >
                                          </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                          <label
                                            class="font-weight-medium body-2"
                                            >Transaction ID
                                            <span class="error--text"
                                              >*</span
                                            ></label
                                          >
                                          <v-text-field
                                            single-line
                                            placeholder="ID"
                                            v-model="
                                              internetPayment.transactionID
                                            "
                                            class="my-0 py-1"
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </form>
                                  </v-container>
                                </v-card>
                              </v-tab-item>
                              <v-tab-item>
                                <v-card flat>
                                  <v-card-text>
                                    <v-card-title
                                      v-show="$vuetify.breakpoint.lg"
                                    >
                                      Enter Demand Draft Details
                                      <v-icon color="primary" right
                                        >mdi-information</v-icon
                                      >
                                    </v-card-title>
                                    <v-card-title
                                      v-show="$vuetify.breakpoint.mdAndDown"
                                      class="text-subtitle-1 font-weight-bold"
                                    >
                                      Enter Demand Draft Details
                                      <v-icon color="primary" right medium
                                        >mdi-information</v-icon
                                      >
                                    </v-card-title>
                                    <v-divider class="my-0"></v-divider>
                                  </v-card-text>
                                  <v-container>
                                    <form>
                                      <v-row>
                                        <v-col cols="12" md="3">
                                          <label
                                            class="font-weight-medium body-2"
                                            >DD No
                                            <span class="error--text"
                                              >*</span
                                            ></label
                                          >
                                          <v-text-field
                                            single-line
                                            placeholder="DD No"
                                            v-model="DD.ddNO"
                                            class="my-0 py-1"
                                          ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                          <label
                                            class="font-weight-medium body-2"
                                            >Drawn On
                                            <span class="error--text"
                                              >*</span
                                            ></label
                                          >
                                          <v-text-field
                                            single-line
                                            placeholder="Drawn On"
                                            v-model="DD.drawnOn"
                                            class="my-0 py-1"
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </form>
                                  </v-container>
                                </v-card>
                              </v-tab-item>
                            </v-tabs-items>
                          </v-col>
                          <!-- <v-col class="12" md="6">
            <v-card-title class="ma-0 pa-0 mb-4">Receipt Type</v-card-title>
            <v-radio-group v-model="radioGroup1" row>
              <v-radio label="Online"></v-radio>
              <v-radio label="Manual"></v-radio>
            </v-radio-group>
          </v-col> -->
                          <!-- <v-col class="12" md="6">
            <label class="text-decoration-underline font-weight-medium body-2">Skip Receipt No.</label>
          </v-col> -->
                          <v-col class="12" md="4">
                            <v-card-title
                              class="ma-0 pa-0 mb-4"
                              v-show="$vuetify.breakpoint.lg"
                              >Date of Payment</v-card-title
                            >
                            <v-card-title
                              class="ma-0 pa-0 mb-4 text-subtitle-1 font-weight-bold"
                              v-show="$vuetify.breakpoint.mdAndDown"
                              >Date of Payment</v-card-title
                            >
                            <custom-date-picker
                              prepend-icon="mdi-calendar"
                              v-model="dateOfPayment"
                            >
                            </custom-date-picker>
                          </v-col>
                        </v-row>
                        <v-card-actions
                          disabled="true"
                          v-if="$vuetify.breakpoint.smAndUp"
                        >
                          <v-row align="center" justify="end">
                            <v-col class="12" md="3">
                              <v-text-field
                                label="Payable Aount"
                                filled
                                dense
                                v-model="stepTwoPayAmount"
                                readonly
                                shaped
                              ></v-text-field>
                            </v-col>
                            <v-col class="12" md="3">
                              <v-btn
                                color="primary"
                                dark
                                @click.prevent="Pay"
                                x-large
                              >
                                <v-icon left dark> mdi-cash-100 </v-icon>
                                Pay Now
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                        <v-card-actions v-else>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                label="Payable Amount"
                                filled
                                dense
                                v-model="stepTwoPayAmount"
                                readonly
                                shaped
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-btn
                                color="primary"
                                dark
                                @click.prevent="Pay"
                                normal
                                block
                              >
                                <v-icon left dark> mdi-cash-100 </v-icon>
                                Pay Now
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </form>

                      <loading-icon :value="isLoading" />
                      <dialog-alert
                        :dialogObj="dialogObj"
                        v-model="dialogObj.show"
                        @clicked="dialogClicked"
                      >
                      </dialog-alert>
                    </v-container>
                    <v-btn elevation="1" color="grey" @click="stepper = 1">
                      <v-icon left>mdi-arrow-left</v-icon>
                      Back
                    </v-btn>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </template>
          </v-col>
        </v-row>
      </div>
      <div class="text-center">
        <v-dialog v-model="payNowDialog" width="600" persistent>
          <v-card>
            <v-card-title class="text-h5 justify-center">
              You need to pay minimum Rs. {{ minimumPayableAmount }}
            </v-card-title>
            <v-card-actions
              class="justify-center"
              :class="$vuetify.breakpoint.mobile ? 'py-4' : 'pt-5 pb-10'"
            >
              <v-spacer></v-spacer>
              <v-row>
                <v-col
                  class="text-center py-0"
                  :class="$vuetify.breakpoint.mobile ? 'mb-2' : ''"
                  cols="12"
                  md="7"
                  sm="7"
                  xs="12"
                >
                  <v-btn
                    color="primary"
                    @click="handlePayNowButton(true)"
                    :block="$vuetify.breakpoint.mobile"
                  >
                    Continue with entered amount
                  </v-btn>
                </v-col>
                <v-col
                  class="text-center py-0"
                  :class="$vuetify.breakpoint.mobile ? 'mb-2' : ''"
                  cols="12"
                  md="5"
                  sm="5"
                  xs="12"
                >
                  <v-btn
                    color="success"
                    @click="handlePayNowButton(false)"
                    :block="$vuetify.breakpoint.mobile"
                  >
                    Pay minimum amount
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import ThankYou from '../../Fees/payment/thankYou'
import ErrorPage from '../../Fees/payment/error'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import DialogAlert from '@/components/template/DialogAlert'
import VCardComponent from '@/components/template/VCardComponent.vue'

export default {
  name: 'OfflinePayments',
  components: {
    ThankYou,
    ErrorPage,
    CustomDatePicker,
    DialogAlert,
    VCardComponent
  },
  props: ['referenceID'],
  data () {
    return {
      dialogPop: false,
      stepper: 1,
      stepperPopUp: 1,
      loading: false,
      dialogAccept: false,
      payLoad1: '',
      cashCardOrderID: '',
      dialogObj: {
        id: '',
        title: '',
        acceptName: '',
        rejectName: '',
        subtitle: '',
        show: false,
        params: {},
        isNo: true,
        isLoadingYes: false,
        isLoadingNo: false,
        types: {
          payment: 'PAYMENT'
        },
        isSubTHtml: false
      },
      // Student info table
      studentHeader: [
        { text: 'Enquiry Code', value: 'enquiryCode', align: 'center' },
        { text: 'Student Name', value: 'studentFirstName', align: 'center' },
        {
          text: 'Franchisee Name',
          value: 'franchisee.companyName',
          align: 'center'
        },
        { text: 'Academic Year', value: 'academicYear', align: 'center' },
        { text: 'Class', value: 'class', align: 'center' },
        {
          text: 'Parent / Guardian Name',
          value: 'fatherName',
          align: 'center'
        },
        {
          text: 'Parent / Guardian Mobile',
          value: 'fatherMobile',
          align: 'center'
        },
        {
          text: 'Parent / Guardian Email',
          value: 'fatherEmailID',
          align: 'center'
        },
        { text: 'Student Gender', value: 'gender', align: 'center' },
        { text: 'Section / Division', value: 'section', align: 'center' }
      ],
      // Installments table
      installmentHeader: [
        { text: 'Pay Now', value: 'enquiryCode', align: 'center' },
        { text: 'Student Name', value: 'studentFirstName', align: 'center' },
        {
          text: 'Franchisee Name',
          value: 'franchisee.companyName',
          align: 'center'
        },
        { text: 'Academic Year', value: 'academicYear', align: 'center' },
        { text: 'Class', value: 'class', align: 'center' },
        {
          text: 'Parent / Guardian Name',
          value: 'fatherName',
          align: 'center'
        },
        {
          text: 'Parent / Guardian Mobile',
          value: 'fatherMobile',
          align: 'center'
        },
        {
          text: 'Parent / Guardian Email',
          value: 'fatherEmailID',
          align: 'center'
        },
        { text: 'Student Gender', value: 'gender', align: 'center' },
        { text: 'Section / Division', value: 'section', align: 'center' }
      ],
      cardType: [
        { text: 'CREDIT CARD', value: 'CREDIT_CARD' },
        { text: 'DEBIT CARD', value: 'DEBIT_CARD' }
      ],
      paymentMode: [],
      bankIFSC: [
        { text: 'MICR Code', value: 'MICR_CODE' },
        { text: 'IFSC Code', value: 'IFSC_CODE' },
        { text: 'Both(MICR/IFSC)', value: 'MICR_IFSC_CODE' }
      ],
      title: '',
      orderID: '',
      model: '',
      dialog1: false,
      isLoading: false,
      isOnlyApplicationFees: false,
      radioGroup1: 1,
      radioGroup2: 1,
      radioGroup3: 1,
      radioGroup4: 1,
      radioGroup5: 1,
      radioGroup6: 1,
      radioGroup7: 1,
      isPrint: true,
      Date: moment().format('YYYY-MM-DD'),
      OfflineCaptureRespos: [],
      isRecipt: false,
      disable: true,
      selectedRows: [],
      selecteditem: '',
      snackbar: false,
      limitCallBack: 0,
      snackbarMsg: '',
      snackbarTimeout: 2000,
      headers: this.getHeaders(),
      // installment header
      installmentHeaders: this.getInsallHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      paginated: false,
      gstType: 'IGST',
      isGST: false,
      isIGST: true,
      isConcession: false,
      loadingComponent: null,
      totalAmount: 0,
      totalAmountDue: 0,
      totalAmountPaid: 0,
      totalConcession: 0,
      totalAmountToPay: 0,
      partialAmount: 0,
      totalCGST: 0,
      totalSGST: 0,
      totalIGST: 0,
      checkedRows: [],
      isSuccess: false,
      isError: false,
      isSelected: '',
      feeSelected: [],
      feeTypeGroup: [],
      sumArray: [],
      breakUpData: [],
      feeTypeNaming: '',
      studentInfo: null,
      feeSummaryInfo: {
        totalAmount: '',
        amountPaid: '',
        remainingAmount: ''
      },
      remainingPaidAmount: 0,
      maximumPayable: 0,
      paymentType: '',
      orderidResponse: '',
      cheque: {
        chequeNO: '',
        chequeDate: '',
        paymentType: '',
        transactionType: '',
        MICRCode: '',
        cheque: '',
        IFSCCode: '',
        bankName: '',
        branchName: ''
      },
      internetPayment: { transactionType: '', bankName: '', transactionID: '' },
      cardSwipe: {
        transactionType: '',
        approvalCode: '',
        cardLastFourDigit: '',
        bankName: '',
        branchName: '',
        remark: ''
      },
      DD: { transactionType: '', ddNO: '', drawnOn: '' },
      dateOfPayment: moment().format('YYYY-MM-DD'),
      payNowDialog: false,
      compulsoryPayableAmount: 0,
      minimumPayableAmount: 0,
      payableAmountError: false,
      payableAmountErrorMsg: '',
      checkMinimumBtn: false,
      stepTwoPayAmount: 0,
      compulsoryPayable: 0
    }
  },
  async created () {
    window.addEventListener('beforeunload', this.beforePageDestroyed)
    window.addEventListener('unload', this.beforePageDestroyed)
    await this.getAllInfo()
    await this.getPaymentOption()
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforePageDestroyed)
    window.removeEventListener('unload', this.beforePageDestroyed)
  },
  watch: {
    model: function (val) {
      if (val === 0) {
        this.paymentType = 'CASH'
      }
      if (val === 1) {
        this.paymentType = 'CHEQUE'
      }
      if (val === 2) {
        this.paymentType = 'CARD_SWIPE'
      }
      if (val === 3) {
        this.paymentType = 'INTERNET_PAYMENT'
      }
      if (val === 4) {
        this.paymentType = 'DEMAND_DRAFT'
      }
      this.DD.ddNO = ''
      this.DD.drawnOn = ''
      this.internetPayment.transactionType = ''
      this.cheque.bankName = ''
      this.internetPayment.transactionID = ''
      this.cardSwipe.cardLastFourDigit = ''
      this.cardSwipe.approvalCode = ''
      this.cardSwipe.remark = ''
      this.internetPayment.bankName = ''
      this.internetPayment.transactionID = ''
      this.cheque.chequeNO = ''
      this.cheque.MICRCode = ''
      this.cheque.branchName = ''
      this.cheque.chequeDate = ''
      this.cardSwipe.bankName = ''
    }
  },
  methods: {
    // Added function for diaglog button
    nextStep (n) {
      if (n === this.feeTypeGroup.length) {
        this.stepperPopUp = 1
      } else {
        this.stepperPopUp = n + 1
      }
    },
    getPaymentOption: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/internetpaymentoption`
        )
        this.paymentMode = data
        console.log(this.paymentMode)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    acceptPayment: async function () {
      try {
        if (this.payLoad1) {
          this.loading = true
          await this.orderAPI(this.payLoad1)
        }
        if (this.cashCardOrderID.data) {
          this.loading = true
          await this.captureAPI(this.cashCardOrderID.data.orderID)
        }
        this.dialogAccept = false
      } catch (e) {
        this.dialogAccept = false
      } finally {
        this.loading = false
      }
    },
    beforePageDestroyed: async function (e) {
      console.log('beforePageDestroyedPayment ONLINE')
      if (this.orderID) {
        e.returnValue = ''
        await this.reject().catch((err) => {
          console.log(err)
        })
        e.preventDefault()
        e.returnValue = false // Seems require this for Chrome
      }
    },
    dialogClicked: async function (value) {
      switch (value.dialog.id) {
        case this.dialogObj.types.payment:
          if (value.isSuccess) {
            Object.assign(this.dialogObj, {
              isLoadingYes: true
            })
            await this.captureAPI(this.dialogObj.params.orderID)
          } else {
            Object.assign(this.dialogObj, {
              isLoadingNo: true
            })
            this.orderID = this.dialogObj.params.id
            await this.reject()
          }
      }
      Object.assign(this.dialogObj, {
        show: false,
        isLoadingYes: false,
        isLoadingNo: false
      })
    },
    openDialog (type, params) {
      this.orderID = params.id
      Object.assign(this.dialogObj, {
        id: type,
        params,
        show: true,
        isSubTHtml: true,
        title: 'Are you sure to complete payment?',
        subtitle:
          `<p>Please click "Yes" to <b>COMPLETE</b> this payment and "No" to <b>CANCEL</b> this payment.</p>` +
          `<p>Receipt No : <b>${params.receiptNo}</b></p>`
      })
    },
    reject: async function () {
      console.log(this.orderID)
      if (!this.orderID) {
        return
      }
      try {
        this.isLoading = true
        await http.patch(`${constants.API_URL}/api/payments/reject/order`, {
          orderID: this.orderID
        })
        this.isLoading = false
        this.dialog1 = false
        this.orderID = ''
        this.model = 0
        this.$dialog.info({
          text: `Offline Payment Rejected !!`,
          title: 'Rejected'
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Reject API --', errorMessage)
        console.log('Reject API : ', errorMessage)
        this.dialog1 = false
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    closePopUp () {
      this.isSuccess = false
      window.location.href = constants.FRONTEND
    },
    openSnackbar (msg) {
      if (!this.snackbar) {
        this.snackbarMsg = msg
        this.snackbar = true
        this.limitCallBack--
      } else {
        // Usage!
        if (this.limitCallBack < 1) {
          this.limitCallBack++
          setTimeout(this.openSnackbar(msg), this.snackbarTimeout)
        }
      }
    },
    changeInstallments: function (type, item) {
      if (type === 'plus') {
        if (item.position >= item.maxPosition) {
          item.position = item.maxPosition
          this.openSnackbar('All due installments are selected.')
        } else {
          item.position = item.position + 1
        }
      } else {
        if (item.position <= item.minPosition) {
          item.position = item.minPosition
          this.openSnackbar('Minimum due till dates installments are selected.')
        } else {
          item.position = item.position - 1
        }
      }
      this.calculatePayAmount()
    },
    // installments
    getInsallHeaders () {
      let header = [
        // { text: 'Pay Now', value: 'isChecked' },
        { text: 'Installments', value: 'name', align: 'center' },
        { text: 'Amount', value: 'amount', align: 'center' }
      ]

      if (this.isConcession) {
        header.push({
          text: 'Concession Amount',
          value: 'amountConcession',
          align: 'center'
        })
      }
      header.push({ text: 'Amount Due', value: 'amountDue', align: 'center' })

      // if (this.isGST) {
      //   if (this.isIGST) {
      //     header.push({ text: 'IGST Amount', value: 'iGSTAmt', align: 'center' })
      //   } else {
      //     header.push({ text: 'CGST Amount', value: 'cGSTAmt', align: 'center' })
      //     header.push({ text: 'SGST Amount', value: 'sGSTAmt', align: 'center' })
      //   }
      // }
      header.push({
        text: 'Amount To Pay',
        value: 'payableAmt',
        align: 'center'
      })
      header.push({ text: 'Due Date', value: 'dueDate', align: 'center' })

      return header
    },

    getHeaders () {
      let header = [
        { text: 'Fee Type', value: 'feeTypeName', align: 'center' },
        // { text: 'Installments', value: 'position', align: 'center', width: 150 },
        { text: 'Amount', value: 'totalAmount', align: 'center' }
      ]

      if (this.isConcession) {
        header.push({
          text: 'Concession Amount',
          value: 'totalConcession',
          align: 'center'
        })
      }
      header.push({
        text: 'Amount Due',
        value: 'totalAmountDue',
        align: 'center'
      })

      // if (this.isGST) {
      //   if (this.isIGST) {
      //     header.push({ text: 'IGST', value: 'totalIGST', align: 'center' })
      //   } else {
      //     header.push({ text: 'CGST', value: 'totalCGST', align: 'center' })
      //     header.push({ text: 'SGST', value: 'totalSGST', align: 'center' })
      //   }
      // }
      header.push({
        text: 'Amount To Pay',
        value: 'totalAmountPayable',
        align: 'center'
      })
      header.push({ text: '', value: 'data-table-expand' })
      return header
    },
    calculatePayAmount () {
      this.totalAmount = 0
      this.totalAmountDue = 0
      this.totalAmountPaid = 0
      this.totalConcession = 0
      this.totalAmountToPay = 0
      this.partialAmount = 0
      this.totalIGST = 0
      this.totalCGST = 0
      this.totalSGST = 0
      this.checkedRows = []
      console.log(this.feeTypeGroup)
      _.forEach(this.feeTypeGroup, (item) => {
        item.totalAmount = 0
        item.totalAmountDue = 0
        item.totalAmountPaid = 0
        item.totalConcession = 0
        item.totalAmountPayable = 0
        item.totalCGST = 0
        item.totalSGST = 0
        item.totalIGST = 0
        _.forEach(item.installments, (itemChild, indexChild) => {
          // if (item.position > indexChild) {
          itemChild.isChecked = true
          item.totalAmount = this.addTwoNumber(
            item.totalAmount,
            itemChild.amount
          )
          item.totalAmountDue = this.addTwoNumber(
            item.totalAmountDue,
            itemChild.amountDue
          )
          item.totalConcession = this.addTwoNumber(
            item.totalConcession,
            itemChild.amountConcession
          )
          item.totalCGST = this.addTwoNumber(item.totalCGST, itemChild.cGSTAmt)
          item.totalSGST = this.addTwoNumber(item.totalSGST, itemChild.sGSTAmt)
          item.totalIGST = this.addTwoNumber(item.totalIGST, itemChild.iGSTAmt)
          item.totalAmountPayable = this.addTwoNumber(
            item.totalAmountPayable,
            itemChild.payableAmt
          )
          this.checkedRows.push(itemChild.id)
          // } else {
          //   itemChild.isChecked = false
          // }
          item.totalAmountPaid = this.addTwoNumber(
            item.totalAmountPaid,
            itemChild.amountPaid
          )
        })
        this.totalAmount = this.addTwoNumber(item.totalAmount, this.totalAmount)
        this.totalAmountPaid = this.addTwoNumber(
          item.totalAmountPaid,
          this.totalAmountPaid
        )
        this.totalAmountDue = this.addTwoNumber(
          item.totalAmountDue,
          this.totalAmountDue
        )
        this.totalConcession = this.addTwoNumber(
          item.totalConcession,
          this.totalConcession
        )
        this.totalIGST = this.addTwoNumber(item.totalIGST, this.totalIGST)
        this.totalCGST = this.addTwoNumber(item.totalCGST, this.totalCGST)
        this.totalSGST = this.addTwoNumber(item.totalSGST, this.totalSGST)
        this.totalAmountToPay = this.addTwoNumber(
          item.totalAmountPayable,
          this.totalAmountToPay
        )
        this.partialAmount = this.totalAmountToPay
      })
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },
    validatePayableAmount: function () {
      this.payableAmountError = false
      this.payableAmountErrorMsg = ''
      if (this.remainingPaidAmount <= 0) {
        this.payableAmountError = true
        this.payableAmountErrorMsg = `You need to pay minimum ${this.minimumPayableAmount} amount.`
      }
      if (this.remainingPaidAmount > this.maximumPayable) {
        this.payableAmountError = true
        this.payableAmountErrorMsg = `You need to pay maximum ${this.maximumPayable} amount.`
      }
      return true
    },
    openPayNowDialog: function () {
      if (
        this.remainingPaidAmount > 0 &&
        this.remainingPaidAmount <= this.minimumPayableAmount
      ) {
        this.payNowDialog = true
      } else if (this.remainingPaidAmount > this.maximumPayable) {
        return this.$dialog.error({
          text: `You need to pay maximum ${this.maximumPayable} amount.`,
          title: 'Error'
        })
      } else if (
        this.remainingPaidAmount > 0 &&
        this.remainingPaidAmount > this.minimumPayableAmount
      ) {
        this.payNowDialog = false
        this.stepTwoPayAmount = this.remainingPaidAmount
        this.stepper = 2
      }
    },
    Pay: async function (event) {
      if (_.isEmpty(this.checkedRows)) {
        this.dialog1 = false
        return this.$dialog.error({
          text: ` Please select at least one installment`,
          title: 'Error'
        })
      }

      if (this.remainingPaidAmount <= 0) {
        this.dialog1 = false
        return this.$dialog.error({
          text: ` Minimum amount 1 Rupee for procced`,
          title: 'Error'
        })
      }

      if (this.remainingPaidAmount > this.feeSummaryInfo.totalAmount) {
        return this.$dialog.error({
          text: ` Amount must be less than actual Amount to pay  `,
          title: 'Error'
        })
      }

      try {
        let payLoad = {
          referenceID: this.referenceID,
          amount: this.checkMinimumBtn
            ? this.minimumPayableAmount
            : this.remainingPaidAmount,
          dateOfPayment: this.dateOfPayment,
          assignFeeInstallmentID: this.checkedRows
        }
        if (this.paymentType === 'CASH') {
          payLoad.transactionType = this.paymentType
        }
        if (this.paymentType === 'CHEQUE') {
          payLoad.chequeNO = this.cheque.chequeNO
          payLoad.chequeDate = this.cheque.chequeDate
          payLoad.transactionType = this.paymentType

          payLoad.bankName = this.cheque.bankName
          payLoad.branchName = this.cheque.branchName
          payLoad.paymentType = this.cheque.paymentType
          if (this.cheque.paymentType === 'MICR_CODE') {
            payLoad.MICRCode = this.cheque.MICRCode
          }
          if (this.cheque.paymentType === 'IFSC_CODE') {
            payLoad.IFSCCode = this.cheque.IFSCCode
          }
          if (this.cheque.paymentType === 'MICR_IFSC_CODE') {
            payLoad.MICRCode = this.cheque.MICRCode
            payLoad.IFSCCode = this.cheque.IFSCCode
          }
        }
        if (this.paymentType === 'CARD_SWIPE') {
          payLoad.transactionType = this.paymentType
          payLoad.approvalCode = this.cardSwipe.approvalCode
          payLoad.cardLastFourDigit = this.cardSwipe.cardLastFourDigit
          payLoad.bankName = this.cardSwipe.bankName

          payLoad.remark = this.cardSwipe.remark
          payLoad.paymentType = this.cardSwipe.transactionType
        }
        if (this.paymentType === 'INTERNET_PAYMENT') {
          payLoad.transactionType = this.paymentType
          payLoad.bankName = this.internetPayment.bankName
          payLoad.transactionID = this.internetPayment.transactionID
          payLoad.paymentType = this.internetPayment.transactionType
        }
        if (this.paymentType === 'DEMAND_DRAFT') {
          payLoad.transactionType = this.paymentType
          payLoad.ddNO = this.DD.ddNO
          payLoad.drawnNO = this.DD.drawnOn
        }
        this.payLoad1 = payLoad
        await this.orderAPI(this.payLoad1)
        if (this.cashCardOrderID.data) {
          this.openDialog(this.dialogObj.types.payment, this.cashCardOrderID.data)
        }
        // this.orderidResponse = orderIDRes.data
        // console.log('    this.orderidResponse ', this.orderidResponse)
        // this.isLoading = false
        // if (this.orderidResponse) {
        //   this.dialog1 = true
        // }
        // this.model = 0
        // return this.$dialog.info({
        //   text: `Offline Payment Saved Successfully`,
        //   title: 'Success'
        // })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.dialog1 = false

        console.log('While saving : ', e)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    orderAPI: async function (payLoad) {
      try {
        this.isLoading = true
        const orderIDRes = await http.post(
          `${constants.API_URL}/api/payments/offline/order`,
          payLoad
        )
        this.cashCardOrderID = orderIDRes
      } catch (e) {
        await this.reject()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        // this.isError = true
        this.dialog1 = false
        console.log('Error Triggered')
        console.log('Order API: ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    captureAPI: async function (orderID) {
      try {
        this.isLoading = true
        const captureResponse = await http.post(
          `${constants.API_URL}/api/payments/offline/capture`,
          { orderID }
        )

        const invoiceRes = await http.get(
          `${constants.API_URL}/api/invoice/${captureResponse.data.paymentOrderData.id}`
        )

        this.OfflineCaptureRespos = invoiceRes

        if (this.OfflineCaptureRespos) {
          this.isSuccess = true
          if (
            (this.OfflineCaptureRespos.data.paymentOrderData
              .referenceURLType === 'ADMISSION_FORM_FIRST_TIME_OFFLINE' &&
              this.OfflineCaptureRespos.data.paymentOrderData.status ===
                'APPROVAL_WAITING') ||
            this.OfflineCaptureRespos.data.paymentOrderData.referenceURLType ===
              'APPLICATION_FORM_OFFLINE'
          ) {
            this.title =
              'Note :Please approve Offline payment from Finance module and generate the fee receipt from student ledger'
            this.isPrint = false
          }
        }

        this.isLoading = false
        this.model = 0
        this.orderID = ''
        this.dialog1 = false
        // this.$dialog.info({
        //   text: `Offline Payment Saved Successfully`,
        //   title: 'Success'
        // })
      } catch (e) {
        await this.reject()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isError = true
        this.dialog1 = false
        console.log('captureAPI: ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getAllInfo: async function () {
      try {
        this.isLoading = true
        let response = await http.get(
          `${constants.API_URL}/api/admission-fee-payment/installments/${this.referenceID}/OFFLINE`
        )
        this.studentInfo = response.data.studentInfo
        const feeTypeData = response.data.feeTypes
        this.feeTypeGroup = feeTypeData.feeTypeGroup.map((item) => {
          if (item.invoiceFeeName === constants.feeType.Tuition_Fees) {
            if (item.position === 0) {
              // Atleast one instalment should be selected
              let pos = item.position + 1
              if (pos <= item.maxPosition) {
                item.position = pos
              }
            }
          }
          return item
        })
        this.isOnlyApplicationFees = this.feeTypeGroup.length === 1
        this.isConcession = feeTypeData.isConcession
        this.gstType = feeTypeData.gstType
        this.isIGST = _.isEqual(feeTypeData.gstType, 'IGST')
        this.isGST = feeTypeData.isGST
        this.calculatePayAmount()
        this.headers = this.getHeaders()
        this.installmentHeaders = this.getInsallHeaders()
        // Fee Summary Data
        this.feeSummaryInfo.totalAmount = this.totalAmount
        this.feeSummaryInfo.amountPaid = this.totalAmountPaid
        this.feeSummaryInfo.remainingAmount = this.totalAmountDue
        this.remainingPaidAmount = this.totalAmountDue
        this.maximumPayable = this.totalAmountDue
        let { compulsoryPayableAmount, minimumPayableAmount } =
          response.data.validationAmount
        this.compulsoryPayableAmount = compulsoryPayableAmount
        this.compulsoryPayable = compulsoryPayableAmount
        this.minimumPayableAmount = minimumPayableAmount
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isError = true

        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    // Installemnt Details Pop Dialog
    modalOpen () {
      this.dialogPop = true
    },
    handlePayNowButton (flag) {
      this.checkMinimumBtn = false
      if (flag) {
        if (this.isOnlyApplicationFees) {
          if (this.remainingPaidAmount < this.compulsoryPayableAmount) {
            this.payableAmountError = true
            this.payableAmountErrorMsg = this.isOnlyApplicationFees
              ? `You should pay amount of ${this.compulsoryPayableAmount} for admission confirmation.`
              : `You should pay more than amount of ${this.compulsoryPayableAmount} for admission confirmation.`
          } else {
            this.stepper = 2
            this.stepTwoPayAmount = this.remainingPaidAmount
          }
        } else {
          if (this.remainingPaidAmount < this.compulsoryPayableAmount) {
            this.payableAmountError = true
            this.payableAmountErrorMsg = `You should pay more than amount of ${this.compulsoryPayableAmount} for admission confirmation.`
          } else {
            this.stepper = 2
            this.stepTwoPayAmount = this.remainingPaidAmount
          }
        }
      } else {
        this.checkMinimumBtn = true
        this.stepTwoPayAmount = this.minimumPayableAmount
        this.stepper = 2
      }
      this.payNowDialog = false
    },
    handleExponential: function (evt) {
      if (
        evt.which !== 8 &&
        evt.which !== 0 &&
        evt.which !== 190 &&
        evt.which !== 17 &&
        evt.which !== 65 &&
        evt.which !== 110 &&
        (evt.which < 48 || evt.which > 57) &&
        (evt.which > 106 || evt.which < 96)
      ) {
        evt.preventDefault()
      }
    }
  }
}
</script>
<style lang="css" scoped>
/* .v-data-table__mobile-row {
  display: table-cell !important;
} */

.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
/* #card-actions   {
   position: top;
   margin-bottom: 30px;
   bottom: 0;

} */
/* .stepper {

  display: flex;

    overflow-x:scroll ;
    overflow-y: hidden;
    white-space: nowrap;

} */
.steps_items {
  padding: 2px !important;
  padding-top: 24px !important;
}
.stepper_content {
  padding: 2px !important;
}

.green-text {
  cursor: pointer;
  color: #4caf50 !important;
  font-weight: 500;
}

.green-holder {
  border: solid 3px #a5c347;
  border-radius: 50%;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.green-holder:hover {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.red-holder {
  border: solid 3px #f44336;
  border-radius: 50%;
}

.red-holder:hover {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.red-text {
  cursor: pointer;
  color: #f44336 !important;
  font-weight: 500;
}

::v-deep .v-input__slot:before {
  width: 60% !important;
}

::v-deep .v-input__slot:after {
  width: 60% !important;
}
</style>
